import { noop } from 'lodash/fp';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { PortalConfigType } from '@portals/api/partners';

export const BrandingContext = createContext<{
  portalConfig: Partial<PortalConfigType>;
  updatePortalConfig: Dispatch<SetStateAction<PortalConfigType>>;
  isPristine: boolean;
  isLoading: boolean;
  revertChanges: () => void;
  saveChanges: () => void;
  defaultValues: Partial<PortalConfigType>;
}>({
  portalConfig: {},
  isPristine: true,
  isLoading: false,
  updatePortalConfig: noop,
  revertChanges: noop,
  saveChanges: noop,
  defaultValues: {},
});

export const useBrandingContext = () => useContext(BrandingContext);
